import React from 'react'
import { DefaultLayout } from '../../layouts'
import { PageDataFetcher, PageHeader } from '../../components'
import { setQuery, fetchEvents } from '../../features/events/slice'
import { PageContent } from './components/page-content'
import { useInternationalization } from '../../features/i18n/hook'
import { Route, Switch } from 'react-router-dom'
import * as pageConfig from './config'
// import UpcomingEvent from './subpages/upcoming'
// import PastEvent from './subpages/past'
import AudienceListener from '../../features/collection/components/audience-listener'
const { PAGE_IMAGE } = pageConfig

const Event = (props) => {
  const { translate } = useInternationalization()

  return (
    <DefaultLayout>
      <AudienceListener />
      <Switch>
        {/* <Route path="/event/past">
          <PastEvent />
        </Route>
        <Route path="/event/upcoming">
          <UpcomingEvent />
        </Route> */}
        <Route path="/event">
          <PageDataFetcher
            stateKey="events"
            fetcher={fetchEvents}
            querySetter={setQuery}
            pageConfig={pageConfig}
            {...props}
          >
            <PageHeader
              title={translate('EVENT', 'plural')}
              description={translate('EVENT', 'page_description')}
              image={PAGE_IMAGE}
              className="pt-5 lg:pt-6 lg:pb-0"
            />
            <PageContent />
          </PageDataFetcher>
        </Route>
      </Switch>
    </DefaultLayout>
  )
}

export { Event }
